import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { WatiScript } from '../../../include/js/wati'
import Header from './header'
import leftArrow from '../../../include/images/tp-left-arrow.svg'
import rightArrow from '../../../include/images/tp-right-arrow.svg'
import vDot from '../../../include/images/vertical-dots.svg'
import blueStar from '../../../include/images/blue-star-icon.svg'
import closeIcon from '../../../include/images/close.svg'
import LeftBar from './leftBar'
import moment from 'moment'
import { isMobile } from 'react-device-detect'

import {
  calcelByDoctor,
  getAppointment,
  loadAppointmentsForHome,
  loadAllAppointmentForStaff,
  loadAppointmentDetail,
  noShow,
  startCall,
} from '../../../store/appointment'
import { loadSeo } from '../../../store/seo'
import { getDoctor, loadDoctorProfile } from '../../../store/doctor'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import SideTabs from './sideTab'
import {
  getDoctorPatient,
  loadAllDoctorpatient,
} from '../../../store/doctorPatient'
import { loadChatList, loadList } from '../../../store/prescription'
import { toast } from 'react-toastify'
import AlertSuccess from '../../common/alertSuccess'
import AlertError from '../../common/alertError'
import AvtarImage from '../../common/avtarImage'
import YesMindy from '../../common/yesMindy'
import NoRecord from '../../common/noRecord'
import { Modal } from 'react-bootstrap'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import NotesThought from './notesThought'
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from '../../../firebase'
import InfiniteScroll from 'react-infinite-scroller'
import { getChats, unreadUpdated } from '../../../store/chats'

class DoctorDashboard extends Component {
  state = {
    appointmentId: '',
    date: moment(),
    time: moment(),
    intervalId: 1,
    type: 'online',
    appointModel: false,
    dropDown: false,
    popUp: false,
    popup2: false,
    appoinId: '',
    sidebarToogle: false,
    cancelConfirm: false,
    isShow: false,
    appoint_id: '',
    patientId: '',
    doctorId: '',
    patientType: '',
    page: 1,
    pagination: {},
    initialData: [],
  }
  toggle = e => {
    if (e) e.preventDefault()
    this.setState({ popUp: !this.state.popUp })
  }
  toggle1 = (id, patientId, doctorId, patientType) => {
    this.setState({
      isShow: !this.state.isShow,
      appoint_id: id,
      patientId: patientId,
      doctorId: doctorId,
      patientType: patientType,
    })
  }
  toggle2 = (id) => {
    this.setState({
      popup2: !this.state.popup2,
      appoinId: id,
    })
  }
  loadFunc = () => {
    if (
      Math.ceil(
        this.props.homeAppointments.pagination.filtered_record /
          this.props.homeAppointments.pagination.record_per_page
      ) > this.state.page
    ) {
      this.props.loadAppointmentsForHome(
        {
          page: this.state.page + 1,
          appointment_date: this.state.date.format('YYYY-MM-DD'),
        },
        this.callbackLoad
      )
      this.setState({page: this.state.page + 1})
    }
  }

  callbackLoad = (res, reset = false) => {
    // console.log('call -----------------------> 2 ', res)
    if (res && res.status === 200) {
      const { data, pagination } = res.data
      this.setState(prevState => ({
        pagination,
        page: reset ? 1 : prevState.page,
        initialData: reset ? data : [...prevState.initialData, ...data]
      }));
    }
  }

  dropDownToggle = e => {
    e.preventDefault()                                  
    this.setState({ dropDown: !this.state.dropDown })
  }

  toggleAppointModel = e => {
    if (e) e.preventDefault()
    this.setState({ appointModel: !this.state.appointModel })
  }
  cancellAppointment = e => {
    e.preventDefault()
    this.props.cancellAppointment(this.state.appointmentId, this.callBack)
    this.setState({ loader: true })
  }
  callBack = res => {
    this.toggle()
    this.setState({ loader: false, cancelConfirm: false })
    this.props.loadAppointmentsForHome({
      appointment_date: this.state.date.format('YYYY-MM-DD'),
    })
    this.props.loadList({
      appointment_date: this.state.date.format('YYYY-MM-DD'),
    })
    this.props.loadChatList({
      appointment_date: moment().format('YYYY-MM-DD'),
    })
    if (res.status === 200) {
      toast(<AlertSuccess message={'Appointment cancelled successfully'} />)
    } else {
      toast(<AlertError message={res.data.error} />)
    }
  }
  reSchule = e => {
    e.preventDefault()
    this.props.history.push({
      pathname: '/doctor/reschedule-appointment',
      state: {
        appointment_id: this.state.appointmentId,
        returnUrl: '/doctor/dashboard/calender',
      },
    })
  }
  componentWillUnmount = () => {
    clearInterval(this.state.intervalId)
  }

  changeData = type => {
    if (type === 'next')
      this.setState({ date: this.state.date.add(1, 'days'), page: 1 }, () => {
        this.props.loadAppointmentsForHome({
          page: this.state.page,
          appointment_date: this.state.date.format('YYYY-MM-DD'),
        }, res => this.callbackLoad(res, true))
        this.props.loadList({
          appointment_date: this.state.date.format('YYYY-MM-DD'),
        })
      })
    if (type === 'prev')
      this.setState({ date: this.state.date.subtract(1, 'days'), page: 1 }, () => {
        this.props.loadAppointmentsForHome({
          page: this.state.page,
          appointment_date: this.state.date.format('YYYY-MM-DD'),
        }, res => this.callbackLoad(res, true))
        this.props.loadList({
          appointment_date: this.state.date.format('YYYY-MM-DD'),
        })
      })
  }

  loadNotification = async () => {
    if (!this.props.doctorProfile._id) return;
    // console.log("Loading notification -----> ", typeof this.props.doctorProfile._id)
      const q = query(
      collection(db, "chatsSummary"),
      where("doctorId", "==", this.props.doctorProfile._id),
      where("readByDoctor", "==", false)
    );
    const snapshot = await getDocs(q);
    const unreadPatientIds = snapshot.docs.map(doc => doc.data().patientId);
    // console.log("noti snapshot : ------> ", unreadPatientIds)
    this.props.unreadUpdated({
      unreadPatientIds,
    });
  }
  capitalize = s => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
  componentDidMount() {
    this.props.loadAppointmentsForHome({
      appointment_date: moment().format('YYYY-MM-DD'),
      page: 1 
    }, this.callbackLoad);
    this.props.loadList({
      appointment_date: this.state.date.format('YYYY-MM-DD'),
    })
    this.props.loadChatList({
      appointment_date: moment().format('YYYY-MM-DD'),
    })
    this.props.loadAllDoctorpatient({
      page: 1,
      appointment_date: this.props.appointment_date,
    })
    const intervalId = setInterval(() => {
      this.setState({ time: moment() })
    }, 100)
    this.setState({ intervalId })
    document.body.className = 'dashboard'
    this.props.loadAppointmentsForHome({
      appointment_date: moment().format('YYYY-MM-DD'),
    })
    this.pollInterval = setInterval(() => {
      this.loadNotification();
    }, 5000);
  }

  noShow = (e, id) => {
    this.setState({ appointmentId: '' })
    e.preventDefault()
    this.props.noShow(id, this.callbackNoShow)
  }
  callbackNoShow = res => {
    this.props.loadAppointmentsForHome({
      page: 1,
      appointment_date: moment().format('YYYY-MM-DD'),
    }, res => this.callbackLoad(res, true))
    if (res.status === 200) {
      toast(<AlertSuccess message={'Record updated.'} />)
    } else {
      toast(<AlertError message={'Something went wrong.'} />)
    }
  }

  onCall = (e, id) => {
    e.preventDefault()
    window.open('/doctor/video-call/' + id, '_blank').focus()
     this.props.startCall(id, this.startCallback)
    //this.props.loadAppointmentDetail(id, this.callback)
  }

  startCallback = res => {
    console.log("res --> ", res.success)
  }

  callback = res => {
    this.props.history.push({
      pathname: '/doctor/video-call',
      state: { detail: res.data },
    })
  }

  toggleSidebar = () => {
    this.setState({ sidebarToogle: !this.state.sidebarToogle })
  }
  render() {
    //const serverMode = process.env.REACT_APP_MODE
    const serverMode = 'ddd'
    const sortedData = [...this.state.initialData]
    .sort((a, b) => moment(a.appointment_time).diff(moment(b.appointment_time)));

    return (
      <>
        {/* <Helmet>
          <script id='wati'>{WatiScript}</script>
        </Helmet> */}
        <ReactTooltip className='testPurple' id="dashboard-tooltip" />
        <div class={this.state.sidebarToogle ? 'dashboard on' : 'dashboard'}>
          <LeftBar />
          <Header
            sidebarToogle={this.state.sidebarToogle}
            toggleSidebar={this.toggleSidebar}
          />
          {!this.props.profileLoading && (
            <div
              class='dashboard-main-container'
              onClick={e => {
                //alert(1);
                e.stopPropagation()
                this.setState({ appointmentId: '' })
              }}>
              <div class='dashboard-top-pannel d-lg-flex align-items-lg-center'>
                <div class='tp-text-box d-flex align-items-center justify-content-between'>
                  <div class='name-on-home'>{`Welcome, ${
                    this.props.profile && this.props.profile.name
                  }`}</div>
                  <div class='tp-heading'>Dashboard</div>
                  <div class='tp-date-desc'>
                    <div
                      class='tp-left-arrow'
                      onClick={() => this.changeData('prev')}>
                      <i className="fa-sharp-duotone fa-arrow-left-from-arc fa-lg" style={{ "--fa-primary-color": "#1d0e3d", "--fa-secondary-color": "#1d0e3d" }}></i>
                    </div>
                    <div class='text'>
                      {this.state.date.format('dddd, D MMM')}
                    </div>
                    <div
                      class='tp-right-arrow'
                      onClick={() => this.changeData('next')}>
                      <i className="fa-sharp-duotone fa-arrow-right-from-arc fa-lg" style={{ "--fa-primary-color": "#1d0e3d", "--fa-secondary-color": "#1d0e3d" }}></i>
                    </div>
                  </div>
                  <div class='tp-time-intro'>
                    <strong>{this.state.time.format('h:mm a')}</strong>
                  </div>
                </div>
                <div class='tp-button-group d-flex align-items-center justify-content-end'>
                  <Link
                    data-tooltip-id="dashboard-tooltip"
                    data-tooltip-content='For walk in/ online patients when you want to record their visit (physical, online, telephonic). Only for existing patients in your record. Else add new patient first to record their visit.'
                    to='/doctor/recordVisit'
                    class='btn2 btn-outline no-shadow'>
                    Record Visit
                  </Link>
                  <Link
                    data-tooltip-id="dashboard-tooltip"                  
                    data-tooltip-content='When you want to create an appointment for your existing patient on their behalf. If new patient then add the patient first.'
                    to='/doctor/newAppointment'
                    class='btn2 btn-outline no-shadow'>
                    + New Appointment
                  </Link>
                  <Link
                    data-tooltip-id="dashboard-tooltip"                  
                    data-tooltip-content='When you want to add a new patient to your dashboard so that you can create an appointment for them or record their visits.'
                    to='/doctor/addPatient'
                    class='btn2 btn-default'>
                    + New Patient
                  </Link>
                </div>
              </div>

              <div class='dashboard-main-pannel d-lg-flex flex-lg-wrap'>
                <div class='pannel-left'>
                  <div class='pannel-header'>
                    <ul class='pannel-page-links d-flex flex-wrap'>
                      <li
                        class={
                          this.state.type === 'online'
                            ? 'ppl-item active'
                            : 'ppl-item'
                        }>
                        <a
                          href='#!'
                          onClick={e => {
                            e.preventDefault()
                            this.setState({ type: 'online' })
                          }}
                          class='ppl-box'>
                          <strong>
                            {this.props.homeAppointments.pagination.filtered_record}
                          </strong>
                          <p>
                            {this.state.date.format('dddd, D MMM') ===
                              moment().format('dddd, D MMM') && 'Today’s'}{' '}
                            Appointment
                          </p>
                        </a>
                      </li>
                      <li
                        class={
                          this.state.type === 'walkin'
                            ? 'ppl-item active'
                            : 'ppl-item'
                        }>
                        <a
                          href='#!'
                          onClick={e => {
                            e.preventDefault()
                            this.setState({ type: 'walkin' })
                          }}
                          class='ppl-box'>
                          <strong>
                            {
                              sortedData.filter(
                                e => e.appointment_type === 'walkin'
                              ).length
                            }
                          </strong>
                          <p>
                            {this.state.date.format('dddd, D MMM') ===
                              moment().format('dddd, D MMM') && 'Today’s'}{' '}
                            Walk-Ins
                          </p>
                        </a>
                      </li>
                      <li class='ppl-item'>
                        <Link to='/doctor/patient' class='ppl-box'>
                          <strong>
                            {this.props.getDoctorPatient.total_record}
                          </strong>
                          <p>My Patients</p>
                        </Link>
                      </li>
                    </ul>
                    {/* <h4>
                      {this.state.date.format('dddd, D MMM') ===
                        moment().format('dddd, D MMM') && 'Today’s'}{' '}
                      {this.state.type === 'online'
                        ? 'Appointment'
                        : 'Walk-Ins'}
                    </h4> */}
                  </div>

                  <div
                    class='appointments-pannel-outer  bg-white border-radius2'>
                    <div class='appointments-pannel add-scrollbar  scrollbar-dynamic'
                    style={{ overflowY: 'auto', height: 'calc(100vh - 325px)' }}
                    ref={(ref) => (this.scrollParentRef = ref)}>
                      <>
                      <InfiniteScroll
                        pageStart={1}
                        initialLoad={false}
                        loadMore={this.loadFunc}
                        hasMore={
                          !this.props.loading &&
                          this.state.pagination &&
                          this.state.pagination.filtered_record !==
                            this.state.pagination.total_record_on_current_page
                        }
                        // loader={
                        //   <div className="loader" key={0}>
                        //     Loading ...
                        //   </div>
                        // }
                        useWindow={false}
                        getScrollParent={() => this.scrollParentRef} // see step 3
                      >
                        {sortedData.filter(e =>
                          this.state.type === 'online'
                            ? e.appointment_type !== 'walkin' &&
                              !e.noShow && !e.forClose &&
                              moment()
                                .subtract({
                                  minutes: e.doctor_id.schedules.time,
                                })
                                .diff(
                                  moment(e.appointment_time).subtract({
                                    hours: 5,
                                    minutes: 30,
                                  }),
                                  'minutes'
                                ) < 0
                            : e.appointment_type === this.state.type &&
                              !e.noShow &&
                              !e.noShow &&
                              !e.forClose &&
                              moment()
                                .subtract({
                                  minutes: e.doctor_id.schedules.time,
                                })
                                .diff(
                                  moment(e.appointment_time).subtract({
                                    hours: 5,
                                    minutes: 30,
                                  }),
                                  'minutes'
                                ) < 0
                        ).length > 0 ? (
                          sortedData
                            .filter(e =>
                              this.state.type === 'online'
                                ? e.appointment_type !== 'walkin' &&
                                  !e.noShow &&
                                  !e.forClose &&
                                  moment()
                                    .subtract({
                                      minutes: e.doctor_id.schedules.time,
                                    })
                                    .diff(
                                      moment(e.appointment_time).subtract({
                                        hours: 5,
                                        minutes: 30,
                                      }),
                                      'minutes'
                                    ) < 0
                                : e.appointment_type === this.state.type &&
                                  !e.noShow &&
                                  !e.noShow &&
                                  !e.forClose &&
                                  moment()
                                    .subtract({
                                      minutes: e.doctor_id.schedules.time,
                                    })
                                    .diff(
                                      moment(e.appointment_time).subtract({
                                        hours: 5,
                                        minutes: 30,
                                      }),
                                      'minutes'
                                    ) < 0
                            )
                            .map(ea => (
                              <div class='person-details d-flex align-items-center justify-content-between'>
                                <div class='person-details-box d-flex align-items-center flex-grow-1'>
                                <div class='dropright mr-3'>
                                    <a
                                      class='dropdown-toggle'
                                      href='#'
                                      data-toggle='dropdown'
                                      aria-haspopup='true'
                                      aria-expanded='false'
                                      onClick={e => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        this.setState({
                                          appointmentId: ea._id,
                                        })
                                      }}>
                                      <img src={vDot} alt='' />
                                    </a>
                                    <div
                                      class={
                                        this.state.appointmentId === ea._id
                                          ? 'dropdown-menu dropdown-custom show'
                                          : 'dropdown-menu dropdown-custom'
                                      }
                                      style={
                                        this.state.appointmentId === ea._id
                                          ? isMobile
                                            ? {
                                                zIndex: 99999999999,
                                                position: 'absolute',
                                                transform:
                                                  'translate3d(-173px, 0px, 0px)',
                                                top: '0px',
                                                left: '0px',
                                                willChange: 'transform',
                                              }
                                            : {}
                                          : {}
                                      }
                                      x-placement={
                                        isMobile ? 'left-start' : 'right-start'
                                      }>
                                      <a
                                        class='dropdown-item'
                                        href='#!'
                                        onClick={e => {
                                          e.preventDefault()
                                          this.props.history.push({
                                            pathname: '/doctor/patient-detail',
                                            state: ea.patient_id._id,
                                          })
                                        }}>
                                        View Profile
                                      </a>
                                      <a
                                        class='dropdown-item'
                                        href='#!'
                                        onClick={e => {
                                          e.preventDefault()
                                          this.props.history.push({
                                            pathname: '/doctor/patient-detail/history',
                                            state: ea.patient_id._id,
                                          })
                                        }}>
                                        View History
                                      </a>
                                      <a
                                        class='dropdown-item'
                                        href='#!'
                                        // onClick={e => {
                                        //   e.preventDefault()
                                        //   this.props.history.push({
                                        //     pathname: '/doctor/patient-detail',
                                        //     state: ea.patient_id._id,
                                        //   })
                                        // }}>
                                        // }}>
                                        onClick={() =>
                                          // console.log("ea : ", ea)
                                          this.toggle1(
                                          ea._id,
                                          ea.patient_id._id,
                                          ea.doctor_id && ea.doctor_id._id,
                                          ea.patient_id.type
                                          )                                        
                                        }>
                                        Notes and Thoughts
                                      </a>
                                      <a
                                        class='dropdown-item'
                                        href='#'
                                        onClick={e => {
                                          e.stopPropagation()
                                          this.dropDownToggle(e)
                                          this.toggle(e)
                                          this.toggleAppointModel(e)
                                          this.setState({
                                            appointmentId: ea._id,
                                          })
                                        }}>
                                        Modify Appointment
                                      </a>
                                      {(moment().diff(
                                        moment(ea.appointment_time).subtract({
                                          hours: 5,
                                          minutes: 30,
                                        }),
                                        'minutes'
                                      ) >= 0 || serverMode === 'development') && (
                                        <a
                                          className='dropdown-item'
                                          href='#!'
                                          onClick={() => this.toggle2(ea._id)}>
                                          No Show
                                        </a>
                                      )}
                                    </div>
                                  </div>
                                  <div
                                    className={
                                      (this.props.unreadPatientIds || []).includes(ea.patient_id._id)
                                        ? 'person-img has-active'
                                        : 'person-img'
                                    }
                                  >
                                    {ea.patient_id.thumb ? (
                                      <img
                                        src={
                                          process.env.REACT_APP_S3URL +
                                          ea.patient_id.thumb
                                        }
                                        alt=''
                                      />
                                    ) : (
                                      <AvtarImage />
                                    )}
                                  </div>
                                  <div class='person-text-box'>
                                    <h3>
                                      {ea.patient_id.first_name +
                                        ' ' +
                                        ea.patient_id.last_name}

                                      {ea.patient_id.star.length > 0 &&
                                        ea.patient_id.star.find(
                                          e =>
                                            e === this.props.doctorProfile._id
                                        ) && (
                                          <i>
                                            <img
                                              src={blueStar}
                                              alt='star-icon'
                                            />
                                          </i>
                                        )}
                                    </h3>
                                    <div class='patient-btn d-flex align-items-center justify-content-left'>
                                      <span className={`patient-tags ml-0 ${ea.appointment_type === 'online' ? 'light-green' : 'light-blue'}`}>
                                        {ea.appointment_type === 'clinic'
                                          ? ea.clinic_type
                                            ? `Clinic ${Number(ea.clinic_type)}`
                                            : 'Clinic'
                                          : this.capitalize(ea.appointment_type)}
                                      </span>
                                      <span
                                        class={
                                          ea.followup
                                            ? 'patient-tags '
                                            : 'patient-tags yellow-tag'
                                        }>
                                        {ea.followup
                                          ? 'Follow Up'
                                          : 'New Patient'}
                                      </span>

                                      <a class='profile-box'>
                                        {ea.patient_id.type === 2 ? (
                                          <i className="fa-duotone fa-users-rectangle fa-lg" style={{ "--fa-primary-color": "#fad448", "--fa-secondary-color": "#3c83a9", "--fa-secondary-opacity": 0.8 }}></i>

                                        ) : (
                                          <i className="fa-duotone fa-square-user fa-xl" style={{ "--fa-primary-color": "#fad448", "--fa-secondary-color": "#3c83a9", "--fa-secondary-opacity": 0.8 }}></i>



                                        )}
                                      </a>
                                    </div>
                                  </div>
                                </div>

                                <div class='pd-right d-flex align-items-center justify-content-end flex-grow-1'>
                                  {ea.appointment_type === 'online' && (
                                    <>
                                      {this.state.type === 'online' && (
                                        <div class=''>
                                          <a
                                            data-tooltip-id="dashboard-tooltip"
                                            data-tooltip-content={
                                              moment().diff(
                                                moment(
                                                  ea.appointment_time
                                                ).subtract({
                                                  hours: 5,
                                                  minutes: 30,
                                                }),
                                                'minutes'
                                              ) > -10 ||
                                              serverMode === 'development'
                                                ? ''
                                                : 'Join will be active 10 minutes before appointment'
                                            }
                                            class='btn btn-blue'
                                            onClick={e => {
                                              if (
                                                moment().diff(
                                                  moment(
                                                    ea.appointment_time
                                                  ).subtract({
                                                    hours: 5,
                                                    minutes: 30,
                                                  }),
                                                  'minutes'
                                                ) > -10 ||
                                                serverMode === 'development'
                                              ) {
                                                this.onCall(e, ea._id)
                                              }
                                            }}
                                            style={{
                                              cursor:
                                                moment().diff(
                                                  moment(
                                                    ea.appointment_time
                                                  ).subtract({
                                                    hours: 5,
                                                    minutes: 30,
                                                  }),
                                                  'minutes'
                                                ) > -10 ||
                                                serverMode === 'development'
                                                  ? 'pointer'
                                                  : 'initial',
                                            }}>
                                            Join Call
                                          </a>
                                        </div>
                                      )}
                                    </>
                                  )}
                                  <div class="d-flex flex-column align-items-end pe-3">
                                    <strong className='pe-3'>
                                      {moment(ea.appointment_time)
                                        .utc()
                                        .format('h:mm a')}
                                    </strong>
                                    {ea.duration &&
                                      <small
                                        class={
                                          ea.duration
                                            ? 'patient-tags '
                                            : 'patient-tags yellow-tag'
                                        }>
                                        {`${ea.duration} Mins`}
                                      </small>
                                    }
                                  </div>

                                </div>
                              </div>
                            ))
                        ) : (
                          <div class='person-details d-flex align-items-center justify-content-between completed'>
                            <p>
                              {this.state.type === 'online' && (
                                <NoRecord
                                  header='You Have No Active Appointments For Today So
                                  Far'
                                  text='aims to put sincere efforts each
                                  day to make the experience of virtual
                                  consultation better for its Mental Health
                                  Experts.'
                                />
                              )}
                            </p>
                          </div>
                        )}
                        {sortedData.filter(e =>
                          this.state.type === 'online'
                            ? e.appointment_type !== 'walkin' &&
                              !e.noShow &&
                              !e.forClose &&
                              moment()
                                .subtract({
                                  minutes: e.doctor_id.schedules.time,
                                })
                                .diff(
                                  moment(e.appointment_time).subtract({
                                    hours: 5,
                                    minutes: 30,
                                  }),
                                  'minutes'
                                ) > 0
                            : e.appointment_type === this.state.type &&
                              !e.noShow &&
                              !e.forClose &&
                              moment()
                                .subtract({
                                  minutes: e.doctor_id.schedules.time,
                                })
                                .diff(
                                  moment(e.appointment_time).subtract({
                                    hours: 5,
                                    minutes: 30,
                                  }),
                                  'minutes'
                                ) > 0
                        ).length > 0 && (
                          <div class='chat-seprator1'>
                            <span>Completed</span>
                          </div>
                        )}

                        {sortedData.filter(e =>
                          this.state.type === 'online'
                            ? e.appointment_type !== 'walkin' &&
                              !e.noShow &&
                              !e.forClose &&
                              moment()
                                .subtract({
                                  minutes: e.doctor_id.schedules.time,
                                })
                                .diff(
                                  moment(e.appointment_time).subtract({
                                    hours: 5,
                                    minutes: 30,
                                  }),
                                  'minutes'
                                ) > 0
                            : e.appointment_type === this.state.type &&
                              !e.noShow &&
                              !e.noShow &&
                              !e.forClose &&
                              moment()
                                .subtract({
                                  minutes: e.doctor_id.schedules.time,
                                })
                                .diff(
                                  moment(e.appointment_time).subtract({
                                    hours: 5,
                                    minutes: 30,
                                  }),
                                  'minutes'
                                ) > 0
                        ).length > 0 ? (
                          sortedData
                            .filter(e =>
                              this.state.type === 'online'
                                ? e.appointment_type !== 'walkin' &&
                                  !e.noShow &&
                                  !e.forClose &&
                                  moment()
                                    .subtract({
                                      minutes: e.doctor_id.schedules.time,
                                    })
                                    .diff(
                                      moment(e.appointment_time).subtract({
                                        hours: 5,
                                        minutes: 30,
                                      }),
                                      'minutes'
                                    ) > 0
                                : e.appointment_type === this.state.type &&
                                  !e.noShow &&
                                  !e.noShow &&
                                  !e.forClose &&
                                  moment()
                                    .subtract({
                                      minutes: e.doctor_id.schedules.time,
                                    })
                                    .diff(
                                      moment(e.appointment_time).subtract({
                                        hours: 5,
                                        minutes: 30,
                                      }),
                                      'minutes'
                                    ) > 0
                            )
                            .map(ea => (
                              <div class='person-details d-flex align-items-center justify-content-between completed'>
                                <div class='person-details-box d-flex align-items-center flex-grow-1'>
                                <div class='dropright mr-3'>
                                    <a
                                      class='dropdown-toggle'
                                      href='#'
                                      data-toggle='dropdown'
                                      aria-haspopup='true'
                                      aria-expanded='false'
                                      onClick={e => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        this.setState({
                                          appointmentId: ea._id,
                                        })
                                      }}>
                                      <img src={vDot} alt='' />
                                    </a>
                                    <div
                                      class={
                                        this.state.appointmentId === ea._id
                                          ? 'dropdown-menu dropdown-custom show'
                                          : 'dropdown-menu dropdown-custom'
                                      }
                                      style={
                                        this.state.appointmentId === ea._id
                                          ? isMobile
                                            ? {
                                                zIndex: 99999999999,
                                                position: 'absolute',
                                                transform:
                                                  'translate3d(-173px, 0px, 0px)',
                                                top: '0px',
                                                left: '0px',
                                                willChange: 'transform',
                                              }
                                            : {}
                                          : {}
                                      }
                                      x-placement={
                                        isMobile ? 'left-start' : 'right-start'
                                      }>
                                      <a
                                        class='dropdown-item'
                                        href='#!'
                                        onClick={e => {
                                          e.preventDefault()
                                          this.props.history.push({
                                            pathname: '/doctor/patient-detail',
                                            state: ea.patient_id._id,
                                          })
                                        }}>
                                        View Profile
                                      </a>
                                      <a
                                        class='dropdown-item'
                                        href='#!'
                                        // onClick={e => {
                                        //   e.preventDefault()
                                        //   this.props.history.push({
                                        //     pathname: '/doctor/patient-detail',
                                        //     state: ea.patient_id._id,
                                        //   })
                                        // }}>
                                        onClick={() =>
                                          // console.log("ea : ", ea)
                                          this.toggle1(
                                          ea._id,
                                          ea.patient_id._id,
                                          ea.doctor_id && ea.doctor_id._id,
                                          ea.patient_id.type
                                          )
                                          }>
                                        Notes and Thoughts
                                      </a>
                                      <a
                                        class='dropdown-item'
                                        href='#!'
                                        onClick={e => {
                                          e.preventDefault()
                                          this.props.history.push({
                                            pathname: '/doctor/patient-detail/history',
                                            state: ea.patient_id._id,
                                          })
                                        }}>
                                        View History
                                      </a>
                                      <a
                                        className='dropdown-item'
                                        href='#!'
                                        onClick={() => this.toggle2(ea._id)}>
                                        No Show
                                      </a>
                                    </div>
                                  </div>
                                  <div
                                    className={
                                      (this.props.unreadPatientIds || []).includes(ea.patient_id._id)
                                        ? 'person-img has-active'
                                        : 'person-img'
                                    }
                                  >
                                    {ea.patient_id.thumb ? (
                                      <img
                                        src={
                                          process.env.REACT_APP_S3URL +
                                          ea.patient_id.thumb
                                        }
                                        alt=''
                                      />
                                    ) : (
                                      <AvtarImage />
                                    )}
                                  </div>
                                  <div class='person-text-box'>
                                    <h3>
                                      {ea.patient_id.first_name +
                                        ' ' +
                                        ea.patient_id.last_name}

                                      {ea.patient_id.star.length > 0 &&
                                        ea.patient_id.star.find(
                                          e =>
                                            e === this.props.doctorProfile._id
                                        ) && (
                                          <i>
                                            <img
                                              src={blueStar}
                                              alt='star-icon'
                                            />
                                          </i>
                                        )}
                                    </h3>
                                    <div class='patient-btn d-flex align-items-center justify-content-left'>
                                      <span className={`patient-tags ml-0 ${ea.appointment_type === 'online' ? 'light-green' : 'light-blue'}`}>
                                        {ea.appointment_type === 'clinic'
                                          ? ea.clinic_type
                                            ? `Clinic ${Number(ea.clinic_type)}`
                                            : 'Clinic'
                                          : this.capitalize(ea.appointment_type)}
                                      </span>
                                      <span
                                        class={
                                          ea.followup
                                            ? 'patient-tags '
                                            : 'patient-tags yellow-tag'
                                        }>
                                        {ea.followup
                                          ? 'Follow Up'
                                          : 'New Patient'}
                                      </span>

                                      <a class='profile-box'>
                                        {ea.patient_id.type === 2 ? (
                                          <i className="fa-duotone fa-users-rectangle fa-lg" style={{ "--fa-primary-color": "#fad448", "--fa-secondary-color": "#3c83a9", "--fa-secondary-opacity": 0.8 }}></i>
                                        ) : (
                                          <i className="fa-duotone fa-square-user fa-xl" style={{ "--fa-primary-color": "#fad448", "--fa-secondary-color": "#3c83a9", "--fa-secondary-opacity": 0.8 }}></i>
                                        )}
                                      </a>
                                    </div>
                                  </div>
                                </div>

                                <div class='pd-right d-flex align-items-center justify-content-end flex-grow-1'>
                                  {/* <div class="pd-text">
                                    <a
                                      target="_blank"
                                      onClick={(e) => e.preventDefault()}
                                    >
                                      <h5>
                                        {moment(ea.appointment_time)
                                          .utc()
                                          .format('h:mm a')}{' '}
                                      </h5>
                                    </a>
                                  </div> */}

                                  {ea.appointment_type === 'online' &&
                                    moment().diff(
                                      moment(ea.appointment_time).subtract({
                                        hours: 5,
                                        minutes: 30,
                                      }),
                                      'minutes'
                                    ) <= 80 && (
                                      <>
                                        {this.state.type === 'online' &&
                                          moment().diff(
                                            moment(
                                              ea.appointment_time
                                            ).subtract({
                                              hours: 5,
                                              minutes: 30,
                                            }),
                                            'minutes'
                                          ) > -10 && (
                                            <div class=''>
                                              <a
                                                data-tooltip-id="dashboard-tooltip"
                                                data-tooltip-content={
                                                  moment().diff(
                                                    moment(
                                                      ea.appointment_time
                                                    ).subtract({
                                                      hours: 5,
                                                      minutes: 30,
                                                    }),
                                                    'minutes'
                                                  ) > -10 ||
                                                  serverMode === 'development'
                                                    ? ''
                                                    : 'Join will be active 10 minutes before appointment'
                                                }
                                                class='btn btn-blue'
                                                onClick={e => {
                                                  if (
                                                    moment().diff(
                                                      moment(
                                                        ea.appointment_time
                                                      ).subtract({
                                                        hours: 5,
                                                        minutes: 30,
                                                      }),
                                                      'minutes'
                                                    ) > -10 ||
                                                    serverMode === 'development'
                                                  ) {
                                                    this.onCall(e, ea._id)
                                                  }
                                                }}
                                                style={{
                                                  cursor:
                                                    moment().diff(
                                                      moment(
                                                        ea.appointment_time
                                                      ).subtract({
                                                        hours: 5,
                                                        minutes: 30,
                                                      }),
                                                      'minutes'
                                                    ) > -10 ||
                                                    serverMode === 'development'
                                                      ? 'pointer'
                                                      : 'initial',
                                                }}>
                                                Join Call
                                              </a>
                                            </div>
                                          )}
                                      </>
                                    )}

                                  <div class="d-flex flex-column align-items-end pe-3">
                                    <strong className='pe-3'>
                                      {moment(ea.appointment_time)
                                        .utc()
                                        .format('h:mm a')}
                                    </strong>
                                    {ea.duration &&
                                      <small
                                        class={
                                          ea.duration
                                            ? 'patient-tags '
                                            : 'patient-tags yellow-tag'
                                        }>
                                        {`${ea.duration} Mins`}
                                      </small>
                                    }
                                  </div>

                                </div>
                              </div>
                            ))
                        ) : (
                          <div style={{ margin: '-18px 10px 10px 22px' }}>
                            {this.state.type === 'walkin' &&
                              sortedData.filter(
                                e => e.appointment_type === 'walkin'
                              ).length === 0 && (
                                <NoRecord
                                  header='You Have No Walk-ins Today So Far'
                                  text='strives to be the best Practice Management Software for Mental Health Experts exclusively'
                                />
                              )}
                          </div>
                        )}

                        {sortedData.filter(e =>
                          this.state.type === 'online'
                            ? e.appointment_type !== 'walkin' && e.noShow
                            : e.appointment_type === this.state.type && e.noShow
                        ).length > 0 && (
                          <div class='chat-seprator1'>
                            <span>
                              No Show{' '}
                              {/* {
                              sortedData.filter((e) =>
                                this.state.type === "online"
                                  ? e.appointment_type !== "walkin" && e.noShow
                                  : e.appointment_type === this.state.type &&
                                    e.noShow
                              ).length
                            } */}
                            </span>
                          </div>
                        )}
                        {sortedData
                          .filter(e =>
                            this.state.type === 'online'
                              ? e.appointment_type !== 'walkin' && e.noShow
                              : e.appointment_type === this.state.type &&
                                e.noShow
                          )
                          .map(ea => (
                            <div class='person-details d-flex align-items-center justify-content-between'>
                              <div class='person-details-box d-flex align-items-center flex-grow-1'>
                              <div class='dropright mr-3'>
                                  <a
                                    class='dropdown-toggle'
                                    href='#'
                                    data-toggle='dropdown'
                                    aria-haspopup='true'
                                    aria-expanded='false'
                                    onClick={e => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      this.setState({ appointmentId: ea._id })
                                    }}>
                                    <img src={vDot} alt='' />
                                  </a>
                                  <div
                                    class={
                                      this.state.appointmentId === ea._id
                                        ? 'dropdown-menu dropdown-custom show'
                                        : 'dropdown-menu dropdown-custom'
                                    }
                                    style={
                                      this.state.appointmentId === ea._id
                                        ? isMobile
                                          ? {
                                              zIndex: 99999999999,
                                              position: 'absolute',
                                              transform:
                                                'translate3d(-173px, 0px, 0px)',
                                              top: '0px',
                                              left: '0px',
                                              willChange: 'transform',
                                            }
                                          : {}
                                        : {}
                                    }
                                    x-placement={
                                      isMobile ? 'left-start' : 'right-start'
                                    }>
                                    <a
                                      class='dropdown-item'
                                      href='#!'
                                      onClick={e => {
                                        e.preventDefault()
                                        this.props.history.push({
                                          pathname: '/doctor/patient-detail',
                                          state: ea.patient_id._id,
                                        })
                                      }}>
                                      View Profile
                                    </a>
                                    <a
                                        class='dropdown-item'
                                        href='#!'
                                        onClick={e => {
                                          e.preventDefault()
                                          this.props.history.push({
                                            pathname: '/doctor/patient-detail/history',
                                            state: ea.patient_id._id,
                                          })
                                        }}>
                                        View History
                                      </a>
                                  </div>
                                </div>
                                <div
                                  className={
                                    (this.props.unreadPatientIds || []).includes(ea.patient_id._id)
                                      ? 'person-img has-active'
                                      : 'person-img'
                                  }
                                >
                                  {ea.patient_id.thumb ? (
                                    <img
                                      src={
                                        process.env.REACT_APP_S3URL +
                                        ea.patient_id.thumb
                                      }
                                      alt=''
                                    />
                                  ) : (
                                    <AvtarImage />
                                  )}
                                </div>
                                <div class='person-text-box'>
                                  <h3>
                                    {ea.patient_id.first_name +
                                      ' ' +
                                      ea.patient_id.last_name}

                                    {ea.patient_id.star.length > 0 &&
                                      ea.patient_id.star.find(
                                        e => e === this.props.doctorProfile._id
                                      ) && (
                                        <i>
                                          <img src={blueStar} alt='star-icon' />
                                        </i>
                                      )}
                                  </h3>
                                  <div class='patient-btn d-flex align-items-center justify-content-left'>
                                    <span className={`patient-tags ml-0 ${ea.appointment_type === 'online' ? 'light-green' : 'light-blue'}`}>
                                      {ea.appointment_type === 'clinic'
                                        ? ea.clinic_type
                                          ? `Clinic ${Number(ea.clinic_type)}`
                                          : 'Clinic'
                                        : this.capitalize(ea.appointment_type)}
                                    </span>

                                    <a class='profile-box'>
                                      {ea.patient_id.type === 2 ? (
                                        <i className="fa-duotone fa-users-rectangle fa-lg" style={{ "--fa-primary-color": "#fad448", "--fa-secondary-color": "#3c83a9", "--fa-secondary-opacity": 0.8 }}></i>

                                      ) : (
                                        <i className="fa-duotone fa-square-user fa-xl" style={{ "--fa-primary-color": "#fad448", "--fa-secondary-color": "#3c83a9", "--fa-secondary-opacity": 0.8 }}></i>



                                      )}
                                    </a>
                                  </div>
                                </div>
                              </div>

                              <div class='pd-right d-flex align-items-center justify-content-end flex-grow-1'>
                                {ea.appointment_type === 'online' && (
                                  <>
                                    {this.state.type === 'online' && (
                                      <div class=''>
                                        <a
                                          data-tooltip-id="dashboard-tooltip"
                                          data-tooltip-content={
                                            moment().diff(
                                              moment(
                                                ea.appointment_time
                                              ).subtract({
                                                hours: 5,
                                                minutes: 30,
                                              }),
                                              'minutes'
                                            ) > -10 ||
                                            serverMode === 'development'
                                              ? ''
                                              : 'Join will be active 10 minutes before appointment'
                                          }
                                          class='btn btn-blue'
                                          onClick={e => {
                                            if (
                                              moment().diff(
                                                moment(
                                                  ea.appointment_time
                                                ).subtract({
                                                  hours: 5,
                                                  minutes: 30,
                                                }),
                                                'minutes'
                                              ) > -10 ||
                                              serverMode === 'development'
                                            ) {
                                              this.onCall(e, ea._id)
                                            }
                                          }}
                                          style={{
                                            cursor:
                                              moment().diff(
                                                moment(
                                                  ea.appointment_time
                                                ).subtract({
                                                  hours: 5,
                                                  minutes: 30,
                                                }),
                                                'minutes'
                                              ) > -10 ||
                                              serverMode === 'development'
                                                ? 'pointer'
                                                : 'initial',
                                          }}>
                                          Join Call
                                        </a>
                                      </div>
                                    )}
                                  </>
                                )}
                                <div class="d-flex flex-column align-items-end pe-3">
                                    <strong className='pe-3'>
                                      {moment(ea.appointment_time)
                                        .utc()
                                        .format('h:mm a')}
                                    </strong>
                                    {ea.duration &&
                                      <small
                                        class={
                                          ea.duration
                                            ? 'patient-tags '
                                            : 'patient-tags yellow-tag'
                                        }>
                                        {`${ea.duration} Mins`}
                                      </small>
                                    }
                                </div>

                              </div>
                            </div>
                          ))}
                          
                          {/* fore close */}
                        {sortedData.filter(e =>
                          this.state.type === 'online'
                            ? e.appointment_type !== 'walkin' && e.forClose
                            : e.appointment_type === this.state.type && e.forClose
                        ).length > 0 && (
                          <div class='chat-seprator1'>
                            <span>
                              Foreclosed{' '}
                              {/* {
                              sortedData.filter((e) =>
                                this.state.type === "online"
                                  ? e.appointment_type !== "walkin" && e.forClose
                                  : e.appointment_type === this.state.type &&
                                    e.forClose
                              ).length
                            } */}
                            </span>
                          </div>
                        )}
                        {sortedData
                          .filter(e =>
                            this.state.type === 'online'
                              ? e.appointment_type !== 'walkin' && e.forClose
                              : e.appointment_type === this.state.type &&
                                e.forClose
                          )
                          .map(ea => (
                            <div class='person-details d-flex align-items-center justify-content-between'>
                              <div class='person-details-box d-flex align-items-center flex-grow-1'>
                              <div class='dropright mr-3'>
                                  <a
                                    class='dropdown-toggle'
                                    href='#'
                                    data-toggle='dropdown'
                                    aria-haspopup='true'
                                    aria-expanded='false'
                                    onClick={e => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      this.setState({ appointmentId: ea._id })
                                    }}>
                                    <img src={vDot} alt='' />
                                  </a>
                                  <div
                                    class={
                                      this.state.appointmentId === ea._id
                                        ? 'dropdown-menu dropdown-custom show'
                                        : 'dropdown-menu dropdown-custom'
                                    }
                                    style={
                                      this.state.appointmentId === ea._id
                                        ? isMobile
                                          ? {
                                              zIndex: 99999999999,
                                              position: 'absolute',
                                              transform:
                                                'translate3d(-173px, 0px, 0px)',
                                              top: '0px',
                                              left: '0px',
                                              willChange: 'transform',
                                            }
                                          : {}
                                        : {}
                                    }
                                    x-placement={
                                      isMobile ? 'left-start' : 'right-start'
                                    }>
                                    <a
                                      class='dropdown-item'
                                      href='#!'
                                      onClick={e => {
                                        e.preventDefault()
                                        this.props.history.push({
                                          pathname: '/doctor/patient-detail',
                                          state: ea.patient_id._id,
                                        })
                                      }}>
                                      View Profile
                                    </a>
                                    <a
                                        class='dropdown-item'
                                        href='#!'
                                        onClick={e => {
                                          e.preventDefault()
                                          this.props.history.push({
                                            pathname: '/doctor/patient-detail/history',
                                            state: ea.patient_id._id,
                                          })
                                        }}>
                                        View History
                                      </a>
                                  </div>
                                </div>
                                <div
                                  className={
                                    (this.props.unreadPatientIds || []).includes(ea.patient_id._id)
                                      ? 'person-img has-active'
                                      : 'person-img'
                                  }
                                >
                                  {ea.patient_id.thumb ? (
                                    <img
                                      src={
                                        process.env.REACT_APP_S3URL +
                                        ea.patient_id.thumb
                                      }
                                      alt=''
                                    />
                                  ) : (
                                    <AvtarImage />
                                  )}
                                </div>
                                <div class='person-text-box'>
                                  <h3>
                                    {ea.patient_id.first_name +
                                      ' ' +
                                      ea.patient_id.last_name}

                                    {ea.patient_id.star.length > 0 &&
                                      ea.patient_id.star.find(
                                        e => e === this.props.doctorProfile._id
                                      ) && (
                                        <i>
                                          <img src={blueStar} alt='star-icon' />
                                        </i>
                                      )}
                                  </h3>
                                  <div class='patient-btn d-flex align-items-center justify-content-left'>
                                    <span className={`patient-tags ml-0 ${ea.appointment_type === 'online' ? 'light-green' : 'light-blue'}`}>
                                      {ea.appointment_type === 'clinic'
                                        ? ea.clinic_type
                                          ? `Clinic ${Number(ea.clinic_type)}`
                                          : 'Clinic'
                                        : this.capitalize(ea.appointment_type)}
                                    </span>

                                    <a class='profile-box'>
                                      {ea.patient_id.type === 2 ? (
                                        <i className="fa-duotone fa-users-rectangle fa-lg" style={{ "--fa-primary-color": "#fad448", "--fa-secondary-color": "#3c83a9", "--fa-secondary-opacity": 0.8 }}></i>

                                      ) : (
                                        <i className="fa-duotone fa-square-user fa-xl" style={{ "--fa-primary-color": "#fad448", "--fa-secondary-color": "#3c83a9", "--fa-secondary-opacity": 0.8 }}></i>



                                      )}
                                    </a>
                                  </div>
                                </div>
                              </div>

                              <div class='pd-right d-flex align-items-center justify-content-end flex-grow-1'>
                                {ea.appointment_type === 'online' && (
                                  <>
                                    {this.state.type === 'online' && (
                                      <div class=''>
                                        <a
                                          data-tooltip-id="dashboard-tooltip"
                                          data-tooltip-content={
                                            moment().diff(
                                              moment(
                                                ea.appointment_time
                                              ).subtract({
                                                hours: 5,
                                                minutes: 30,
                                              }),
                                              'minutes'
                                            ) > -10 ||
                                            serverMode === 'development'
                                              ? ''
                                              : 'Join will be active 10 minutes before appointment'
                                          }
                                          class='btn btn-blue'
                                          onClick={e => {
                                            if (
                                              moment().diff(
                                                moment(
                                                  ea.appointment_time
                                                ).subtract({
                                                  hours: 5,
                                                  minutes: 30,
                                                }),
                                                'minutes'
                                              ) > -10 ||
                                              serverMode === 'development'
                                            ) {
                                              this.onCall(e, ea._id)
                                            }
                                          }}
                                          style={{
                                            cursor:
                                              moment().diff(
                                                moment(
                                                  ea.appointment_time
                                                ).subtract({
                                                  hours: 5,
                                                  minutes: 30,
                                                }),
                                                'minutes'
                                              ) > -10 ||
                                              serverMode === 'development'
                                                ? 'pointer'
                                                : 'initial',
                                          }}>
                                          Join Call
                                        </a>
                                      </div>
                                    )}
                                  </>
                                )}
                                <div class="d-flex flex-column align-items-end pe-3">
                                    <strong className='pe-3'>
                                      {moment(ea.appointment_time)
                                        .utc()
                                        .format('h:mm a')}
                                    </strong>
                                    {ea.duration &&
                                      <small
                                        class={
                                          ea.duration
                                            ? 'patient-tags '
                                            : 'patient-tags yellow-tag'
                                        }>
                                        {`${ea.duration} Mins`}
                                      </small>
                                    }
                                </div>

                              </div>
                            </div>
                          ))}
                        </InfiniteScroll>
                      </>
                    </div>
                  </div>
                </div>
                <SideTabs
                  appointment_date={this.state.date.format('YYYY-MM-DD')}
                />
              </div>
            </div>
          )}
          <Modal
            className='modal fade custom-modal'
            show={this.state.cancelConfirm}
            onHide={e => this.setState({ cancelConfirm: false })}>
            <div class='modal-body'>
              <h6>Cancel Appointment</h6>
              <p>Are you sure you want to cancel the appointment?</p>{' '}
              <div class='custom-modal-btn'>
                <a
                  disabled={this.state.loader}
                  href='#!'
                  class={
                    this.state.loader
                      ? 'btn btn-primary btn-block disabled'
                      : 'btn btn-primary btn-block'
                  }
                  onClick={e =>
                    this.cancellAppointment(e, this.state.appointId)
                  }>
                  Yes
                </a>
                <a
                  href='#!'
                  class='btn-text'
                  onClick={e => this.setState({ cancelConfirm: false })}>
                  Don’t Cancel
                </a>
              </div>
            </div>
          </Modal>
          <Modal
            className='modal fade custom-modal'
            show={this.state.popUp}
            onHide={this.toggle}>
            <div class='modal-body'>
              <h6>Modify Appointment?</h6>
              <p>Do you wish to cancel or reschedule your appointment</p>
              <div class='custom-modal-btn'>
                <a
                  onClick={e => this.reSchule(e)}
                  href='#!'
                  class='btn btn-primary no-shadow btn-block'>
                  Reschedule Appointment
                </a>
                <a
                  disabled={this.state.loader}
                  href='#!'
                  class={
                    this.state.loader
                      ? 'btn btn-outline btn-block disabled'
                      : 'btn btn-outline btn-block'
                  }
                  onClick={e => this.setState({ cancelConfirm: true })}>
                  Cancel Appointment
                </a>
                <a href='#!' class='btn-text' onClick={this.toggle}>
                  Don’t Modify
                </a>
              </div>
            </div>
          </Modal>
          <NotesThought
          isShow={this.state.isShow}
          toggle={this.toggle1}
          stateData={this.state}
          appoint_id={this.state.appoint_id}
          patientId={this.state.patientId}
          doctorId={this.state.doctorId}
          patientType={this.state.patientType}
          />
          <Modal
            aria-labelledby='contained-modal-title-vcenter'
            centered
            dialogClassName='modal-dialog modal-dialog-centered modal-sm'
            className='modal fade '
            show={this.state.popup2}>
            <>
              <div class='modal-header'>
                <button
                  onClick={() => {
                    this.setState({popup2: !this.state.popup2})
                  }}
                  type='button'
                  class='close'
                  data-dismiss='modal'>
                  <img src={closeIcon} alt='close popup' />
                </button>
              </div>
              <div class='modal-body'>
                <p>You are requesting for No Show protocol to initiate as the patient didnt join till 20mins into the appointment. Are you sure you want to proceed ?</p>
                {/* <p style={{ fontSize: '13px', color: '#666' }}>(You can also ask the patient to join through a whatsapp message by clicking on option "Ask to join" from menu above)</p> */}
                <div class='modal-action-btn'>
                  <a
                    href='#!'
                    class='btn btn-outline no-shadow'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={e => {
                      e.preventDefault()
                      this.setState({popup2: !this.state.popup2})
                    }}>
                    Close
                  </a>
                  <a
                    href='#!'
                    class='btn btn-primary'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={en => {
                      this.noShow(en, this.state.appoinId)
                      this.setState({popup2: !this.state.popup2})
                      }}>
                    Confirm
                  </a>
                </div>
              </div>
            </>
          </Modal>  
        </div>
      </>
    )
  }
}
const mapDispatchToProps = dispatch => ({
  loadSeo: page_key => dispatch(loadSeo(page_key)),
  loadDoctorProfile: () => dispatch(loadDoctorProfile()),
  loadAllDoctorpatient: params => dispatch(loadAllDoctorpatient(params)),
  loadAppointmentsForHome: (params, callback = null) =>
    dispatch(loadAppointmentsForHome(params, callback)),
  loadAppointmentDetail: (id, callback) =>
    dispatch(loadAppointmentDetail(id, callback)),
  loadList: params => dispatch(loadList(params)),
  loadChatList: params => dispatch(loadChatList(params)),
  noShow: (id, callback) => dispatch(noShow(id, callback)),
  cancellAppointment: (id, callBack) => dispatch(calcelByDoctor(id, callBack)),
  unreadUpdated: (payload) => dispatch(unreadUpdated(payload)),
  startCall: (id, callback) => dispatch(startCall(id, callback)),
})
const mapStateToProps = state => ({
  profile: getDoctor(state).profile,
  profileLoading: getDoctor(state).profileLoading,
  doctorProfile: getDoctor(state).profile,
  getDoctorPatient: getDoctorPatient(state).doctorPatient.pagination,
  getAppointment: getAppointment(state).doctorAppointment,
  homeAppointments: getAppointment(state).homeAppointments,
  loading: getAppointment(state).loadingDoctorAppointment,
  unreadPatientIds: getChats(state).unreadPatientIds,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DoctorDashboard)
)
